import React from 'react';
import './Story.css';

const Story = () => {
  return (
    <section className="story-section">
      <div className="story-container">
        <div className="story-header">
          <h2>
            <span className="story-title-line">THE</span>
            <span className="story-title-line"><span className='blue-text'>STORY</span></span>
          </h2>
        </div>
        
        <div className="story-content-wrapper">
          <div className="story-text-content">
            <h3 className="story-subtitle">BELIEVING THERE IS MORE TO<br />SOFTWARE DEVELOPMENT</h3>
            
            <p className="story-paragraph">
                Bijan Burnard founded Lattice Labs after a realisation whilst managing one of his projects as a PMO.
            </p>
            
            <blockquote className="story-quote">
              "Having been a Senior Developer and Project Manager for large corporations, I believed the development process was broken and it could be improved by simply focusing more on the end user."
            </blockquote>
          </div>
          
          <div className="story-photo-container">
            <img 
              src="/founder.jpeg" 
              alt="Trago Franco, Founder of Imaginary Cloud" 
              className="founder-photo"
            />
          </div>
        </div>

        <div className="story-continued">
          <p className="story-paragraph">
           With a strong background in Software Engineering acquired from distinguished entities, Bijan started his career on complex and quality-centric software projects. Quality-centric software is often challenging to use and prone to human error because it doesn't focus on the user. Conversely, many companies prioritise user experience but compromise on quality. Recognising the need to merge these aspects, Bijan founded Lattice Labs, a software development company dedicated to creating user-centric, reliable, and scalable solutions that drive digital transformation.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Story;